(() => {
  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();
  const amountFrom = (value) => {
    const match = value.replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  };
  const formatLike = (amount, example) => {
    const clean = example.trim();
    const prefix = clean.match(/^[^\d-]*/)?.[0] || '';
    const suffix = clean.match(/[^\d]*$/)?.[0] || '';
    return `${prefix}${amount.toFixed(2)}${suffix}`;
  };
  const rowKey = (row) => {
    const title = normalize(row.querySelector('.cart-items__title')?.textContent || '');
    const details = normalize(row.querySelector('.cart-items__variants-wrapper')?.textContent || '')
      .replace(/\b\d+\s+orders?\b/g, '{orders}');
    const unit = normalize(row.querySelector('.cart-items__unit-price-wrapper')?.textContent || '');
    const href = row.querySelector('.cart-items__title')?.getAttribute('href') || '';
    let productPath = href;
    try {
      productPath = new URL(href, location.origin).pathname;
    } catch {}
    return [productPath, title, details, unit].join('|');
  };
  const lineData = (row) => {
    const input = row.querySelector('input[data-cart-line]');
    const currentQuantity = Math.max(0, Number.parseInt(input?.value || '0', 10) || 0);
    const storedQuantity = Number.parseInt(row.dataset.nmOriginalQuantity || '', 10);
    const quantity = Number.isFinite(storedQuantity) ? storedQuantity : currentQuantity;
    const unitText = row.querySelector('.cart-items__unit-price-wrapper bdi')?.textContent || '';
    return {
      row,
      input,
      quantity,
      unitAmount: amountFrom(unitText),
      key: row.dataset.key || '',
      editable: Boolean(input && !input.disabled),
      removable: Boolean(row.querySelector('.cart-items__remove:not([hidden]):not(:disabled)')),
    };
  };
  const hideOrderLabel = (row) => {
    const orderPattern = /^\s*\d+\s+orders?\s*$/i;
    const details = row.querySelector('.cart-items__variants-wrapper');
    if (!details) return;
    const orderLabels = Array.from(details.querySelectorAll('*')).filter((element) => {
      if (!orderPattern.test(element.textContent || '')) return false;
      return !Array.from(element.children).some((child) => orderPattern.test(child.textContent || ''));
    });
    if (orderLabels.length === 0 && orderPattern.test(details.textContent || '')) {
      orderLabels.push(details);
    }
    for (const orderLabel of orderLabels) {
      const wrapper = orderLabel.closest('.cart-items__variant, .cart-items__property') || orderLabel;
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
      wrapper.style.setProperty('display', 'none', 'important');
    }
  };
  const setHidden = (row, hidden) => {
    if (hidden) {
      row.dataset.nmClientGrouped = 'true';
      row.hidden = true;
      row.setAttribute('aria-hidden', 'true');
      row.style.setProperty('display', 'none', 'important');
    } else if (row.dataset.nmClientGrouped === 'true') {
      delete row.dataset.nmClientGrouped;
      row.hidden = false;
      row.removeAttribute('aria-hidden');
      row.style.removeProperty('display');
    }
  };
  const groupCart = (root) => {
    const rows = Array.from(root.querySelectorAll('tr.cart-items__table-row:not(.cart-items__nested-line)'));
    const groups = new Map();
    for (const row of rows) {
      const key = rowKey(row);
      if (!key) continue;
      hideOrderLabel(row);
      const group = groups.get(key) || [];
      group.push(lineData(row));
      groups.set(key, group);
    }
    for (const group of groups.values()) {
      if (group.length < 2) {
        setHidden(group[0].row, false);
        delete group[0].row.dataset.nmOriginalQuantity;
        continue;
      }
      const primary = group.find((item) => item.editable) || group[0];
      for (const item of group) {
        if (!item.row.dataset.nmOriginalQuantity) {
          item.row.dataset.nmOriginalQuantity = String(item.quantity);
        }
      }
      const quantity = group.reduce((sum, item) => sum + item.quantity, 0);
      const lineTotal = group.reduce((sum, item) => sum + item.unitAmount * item.quantity, 0);
      for (const item of group) setHidden(item.row, item !== primary);
      primary.row.dataset.nmGroup = JSON.stringify(
        group.map((item) => ({
          key: item.key,
          quantity: item.quantity,
          editable: item.editable,
          removable: item.removable,
        }))
      );
      if (primary.input && primary.input.value !== String(quantity)) {
        primary.input.value = String(quantity);
      }
      const price = primary.row.querySelector('.cart-items__price text-component');
      const bdi = price?.querySelector('bdi');
      if (price && bdi && lineTotal > 0) {
        const example = price.getAttribute('value') || bdi.textContent || '';
        const formatted = formatLike(lineTotal, example);
        if (price.getAttribute('value') !== formatted) price.setAttribute('value', formatted);
        if (bdi.textContent !== formatted) bdi.textContent = formatted;
      }
    }
  };
  let scheduled = false;
  const apply = () => {
    scheduled = false;
    for (const cart of document.querySelectorAll('cart-items-component')) groupCart(cart);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(apply);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-cart-drawer-trigger], cart-icon, .cart-drawer__open')) schedule();
  });
})();
